import { SecurityPolicies } from "../../../Plans/Templates/SecurityPolicies";

export function Security({ kernel, type="profile" }) {
    return(<SecurityPolicies kernel={kernel} type="profile"/>)
}
